// import * as sha1 from 'js-sha1'
import constants from '@/constants'
import _ from 'lodash'
// const aux = {
//   // translation: function (value, locale, language) {
//   //   let aux = value
//   //   try {
//   //     aux = JSON.parse(value)
//   //   } catch (e) {}
//   //   if (aux[locale]) {
//   //     return aux[locale]
//   //   } else if (aux['en']) {
//   //     return aux['en']
//   //   } else {
//   //     const firstKey = Object.keys(aux)[0]
//   //     return aux[firstKey]
//   //   }
//   // },
//   verifyURL: function (url) {
//     if (url.indexOf('www') >= 0 || url.indexOf('http') >= 0) return url
//     return `${window.location.protocol}//www.${url}`
//   }
// }

//const utils = {
export default  {
  formatNumber(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  getColor (value) {
    if (value === 'DESCUBREGROUP') return '#FFA726'
    else if (value === 'BPESTACIONES') return '#557755'
    else if (value === 'RUYBESA') return '#E53935'
    else if (value === 'CAJASIETE') return '#375652'
    else if (value === 'MHI') return '#8E8783'
    else if (value === 'PARQUE') return '#044C74'
    else if (value === 'DGPLUS') return '#27DAF5'
    else if (value === 'BARCELO') return '#d12726'
    else if (value === 'BINTER') return '#008900'
    else if (value === 'TDT') return 'blue'
    else if (value === 'LOPESAN') return 'brown'
    else if (value === 'CORAL') return 'orange'
    else if (value === 'INTUROTEL') return 'pink'
    else if (value === 'HTOP') return '#00a9d1'
    else if (value === 'DREAMPLACE') return 'black'
    else if (value === 'MONDAY') return '#00faba'
    else return '#CCCCCC'
  },
  getStatus (value) {
    const aux = new Date() - new Date(value)
      var cd = 24 * 60 * 60 * 1000,
          ch = 60 * 60 * 1000,
          d = Math.floor(aux / cd),
          h = Math.floor( (aux - d * cd) / ch),
          m = Math.round( (aux - d * cd - h * ch) / 60000),
          pad = function(n){ return n < 10 ? '0' + n : n; };
    if( m === 60 ){
      h++
      m = 0
    }
    if( h === 24 ){
      d++
      h = 0
    }

    if (d >= 1) {
      return { //error
        error: true,
        icon: 'mdi-close-network',
        color: '#D32F2F'
      }
    } else if (h >= 1) {
      return { //naranja
        icon: 'mdi-network-off',
        color: '#FFA726'
      }
    } else if ((h * 60 + m) >= 16) {
      return { //naranja
        icon: 'mdi-network-off',
        color: '#FFD180'
      }
    }  else {
      return { //correcto
        icon: 'mdi-check-network',
        color: '#7CB240'
      }
    }
    return { //error
      icon: 'mdi-close-network',
      color: '#D32F2F'
    }
  },
  getDownloadStatus (value) {
    const aux = new Date() - new Date(value)
      var cd = 24 * 60 * 60 * 1000,
          ch = 60 * 60 * 1000,
          d = Math.floor(aux / cd),
          h = Math.floor( (aux - d * cd) / ch),
          m = Math.round( (aux - d * cd - h * ch) / 60000),
          pad = function(n){ return n < 10 ? '0' + n : n; };
    if( m === 60 ){
      h++;
      m = 0;
    }
    if( h === 24 ){
      d++;
      h = 0;
    }

    if (d >= 15) {
      return true
    } else {
      return false
    }
  },
  transfMenu (oldValue, newValue) {
    if (!oldValue.noRestore) { // se utilizar para cuando se guarda la edición del menú [formMenu/index]
      oldValue.Name = newValue.Name
      oldValue.Menus = newValue.Menus
      oldValue.Type = newValue.Type
      // oldValue.IsMenuWithSubmenu = newValue.IsMenuWithSubmenu
    }
  },
  isMobile () {
    if (navigator.userAgent.match(/iPad/i) != null) return false
    if (navigator.userAgent.match(/Mobi/)) return true
    if ('screen' in window && window.screen.width <= 800 && window.screen.height <= 600) return true

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
    if (connection && connection.type === 'cellular') return true

    return false
  },
  isIpad () {
    return navigator.userAgent.match(/iPad/i) != null
  },
  getUserID () {
    return localStorage.getItem('user') 
  },
  getEnterpiseID () {
    return localStorage.getItem('enterprise') 
  },
  isPrivate: function () {
    const host = window.location.host
    const parts = host.split('.')
    const domainLength = 3 // route1.example.com => domain length = 3
    if (parts.length === (domainLength - 1)) {
      return true
    } else if (parts[0] === 'www') {
      if (parts[0] === 'www' && (parts[1] === 'admin' || parts[1] === process.env.VUE_APP_URL)) {
        return true
      }
    } else if (parts[0] === 'admin') {
      return true
    }
    return false
  },
  getDomain: function () {
    const getHostname = window.location.hostname
    return getHostname.split('.')[0] === 'www' ? getHostname.split('.')[1] : getHostname.split('.')[0]
  },
  getAPIURL: function (path, isPrivate, id) {
    const hostname = window.location.hostname
    const pathSplit = hostname.split('.')
    let domain = ''
    if (pathSplit.length > 2) {
      domain = pathSplit[0] === 'www' ? pathSplit[1] : pathSplit[0]
    }
    if (domain === process.env.VUE_APP_API_URL.split('.')[0] || domain === 'admin') domain = ''
    domain = !isPrivate && domain.length === 0 ? id : domain
    const area = isPrivate ? 'private' : 'public'
    let www = process.env.VUE_APP_ENV === 'development' ? '' : 'www.'
    let result = `${window.location.protocol}//${www}${process.env.VUE_APP_API_URL}/${area}/${path}`
    // old 2090806
    // if (id && isPrivate) result = `${result}/${id}`
    // // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`?domain=${domain}`)
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`/${domain}`)
    // old 2090806
    // new 2090806
    if (id && isPrivate) result = `${result}/${id}`
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : result.concat(`?domain=${domain}`)
    // return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : id ? result.concat(`/${id}`) : result.concat(`/${domain}`)
    return isPrivate ? result.concat(`?token=${localStorage.getItem('jwt')}`) : id ? result.concat(`/${id}`) : result
    // new 2090806
  
  },
  getAllLanguages (selectedLanguages) {
    const languages = []
    for (var key in constants.isoLangs) {
      languages.push({
        ID: key,
        Name: constants.isoLangs[key].nativeName.split(', ').join('-')
      })
    }
    if (selectedLanguages) {
      return languages.filter(x => selectedLanguages.indexOf(x.ID) >= 0)
    }
    return languages
  },
  setActiveEnterprise: function (v_, enterprise, redirect) {
    if (enterprise) {
      localStorage.setItem('enterprise', enterprise.ID)
      v_.$store.state.app.enterpriseID = enterprise ? enterprise.ID : null
      v_.$store.state.app.enterpriseName = enterprise ? enterprise.Name : ''
    }
    if (redirect) v_.$router.push('/dashboard')
  },
  getActiveEnterpriseID: function (v_) {
    return (v_.$store.state.app.enterpriseID)
  },
  getActiveEnterpriseColor: function (v_) {
    return (v_.$store.state.app.enterpriseColor)
  },
  checkIsActive(menu) {
    if (!menu.IsTemp) {
      return true
    } else {
      if (menu.StartDate <= new Date() && (menu.EndDate >= new Date() || menu.NoEndDate)) {
        return true
      } else {
        return false
      }
    }
  },
  getTranslation: function (value, locale) {
    let aux = value
    // try {
    //   aux = JSON.parse(value)
    // } catch (e) {
    //   console.log(e)
    // }
    if (aux[locale]) {
      return aux[locale]
    } else if (aux['en']) {
      return aux['en']
    } else {
      const firstKey = Object.keys(aux)[0]
      return aux[firstKey]
    }
  },
  pad: function (value, nItem = 2) {
    let aux = ''
    for (let i = 0; i < nItem; i++) aux = aux.concat('0')
    let result = aux.concat(value)
    result = result.substring(result.length - nItem, result.length)
    return result
  },
}

//export default utils
